const RecordIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { RecordIcon as default };
//# sourceMappingURL=RecordIcon.js.map
